module.exports = __webpack_public_path__ + "static/media/progress_header_1.5b229649.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/progress_header_1.svg
// module id = 655
// module chunks = 0